import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { API_ENDPOINT } from "helpers/Endpoints/endpoints";

export const fetchSettings = createAsyncThunk(
  "settings/fetchSettings",
  async (_, { rejectWithValue }) => {
    try {
      const response: any = await Axios.get(API_ENDPOINT.USER_MANAGEMENT?.SETTINGS?.GET ?? "");
      return response?.data ?? response;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch settings",
      );
    }
  },
);

export const updateSettings = createAsyncThunk(
  "settings/updateSettings",
  async (
    { payload }: { payload: { bank_details?: any[]; lut_number?: any[] } },
    { rejectWithValue },
  ) => {
    try {
      const response: any = await Axios.put(
        API_ENDPOINT.USER_MANAGEMENT?.SETTINGS?.UPDATE ?? "",
        payload,
      );
      return response?.data ?? response;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to update settings",
      );
    }
  },
);

export const setCurrentBankOrLut = createAsyncThunk(
  "settings/setCurrentBankOrLut",
  async (
    { type, id }: { type: "bank" | "lut"; id: number },
    { rejectWithValue },
  ) => {
    try {
      const response: any = await Axios.post(
        API_ENDPOINT.USER_MANAGEMENT?.SETTINGS?.SET_CURRENT ?? "",
        { type, id },
      );
      return response?.data ?? response;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to set current",
      );
    }
  },
);
